export const emitAsyncMixin = {
  methods: {
    async $emitAsync(method, ...params) {
      let listener =
        this.$listeners[method] || this.$attrs[method] || this[method];
      if (listener) {
        let res = await listener(...params);
        return res === undefined || res;
      }
      return false;
    },
  },
};
